import { render, staticRenderFns } from "./PushModal.vue?vue&type=template&id=71e352c2&scoped=true"
import script from "./PushModal.vue?vue&type=script&lang=js"
export * from "./PushModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e352c2",
  null
  
)

export default component.exports